import { RestSlice } from '../../../../redux/rest.slice';
import { IppIndustrySample } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const ippSamplesReadyToReportSlice = new RestSlice<IppIndustrySample>(
	localizationService.getLocalizedString('ipp.samples.readyToReport'),
	Resource.IppIndustrySamples
);
export default ippSamplesReadyToReportSlice.rests.reducer;
